/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Preview_Audio_TitleInputs */



/**
* | output |
* | --- |
* | "Preview event audio" |
*
* @param {Event_Ad_Preview_Audio_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_preview_audio_title = /** @type {((inputs?: Event_Ad_Preview_Audio_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Preview_Audio_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Previsualiser l'audio de l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorschau der Veranstaltung (Audio)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima audio dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр аудиособытия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa del audio del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预览活动音频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント音声のプレビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट ऑडियो का पूर्वावलोकन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-visualização do áudio do evento")
	return /** @type {LocalizedString} */ ("Preview event audio")
});